<div class="wrapper" #wrapper>
  @for (element of elements$ | async; track element) {
    <div class="action">
      @if (isTemplateRef | thunk: element) {
        <ng-template *ngTemplateOutlet="element; context: getContext | thunk: element" />
      }
      @if (!(isTemplateRef | thunk: element)) {
        <ng-template *ngComponentOutlet="element" />
      }
    </div>
  }
</div>
